import React, { useState } from "react";
import { Modal, Box, Typography, Grid, Button, Select, MenuItem, IconButton, } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch, useSelector } from "react-redux";
import { closeWeightDisputeRequest, uploadImageByCarrierRequest } from "@/redux/actions";
import { enqueueSnackbar } from "notistack";
const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 600,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    borderRadius: "12px",
};
const RejectDisputeBulkModal = ({ open, onClose, selectedRow, setIsBackOpenOpen, }) => {
    const dispatch = useDispatch();
    const [reason, setReason] = useState("");
    const [flag, setFlag] = useState(true);
    const [file, setFile] = useState(null);
    const [uploadedFileUrl, setUploadedFileUrl] = useState("");
    const uploadByCarrierState = useSelector((state) => state.uploadImageByCarrierReducer);
    const handleFileChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            setFile(e.target.files[0]);
        }
    };
    const handleUploadFile = () => {
        if (!file)
            return;
        setIsBackOpenOpen(true);
        dispatch(uploadImageByCarrierRequest({
            carrierRejectfile: file,
            tenantId: selectedRow.tenantId,
        }));
    };
    const handleRejectDispute = () => {
        console.log("Rejecting dispute with reason:", file);
        if (selectedRow) {
            setIsBackOpenOpen(true);
            dispatch(closeWeightDisputeRequest({
                tenantId: selectedRow.tenantId,
                batchId: selectedRow === null || selectedRow === void 0 ? void 0 : selectedRow.batchId,
                orderIds: selectedRow.orderIds,
                weightDisputeStatus: "rejected_by_carrier",
                carrierRejectReason: reason,
                carrierRejectFileUrl: uploadedFileUrl,
            }));
        }
    };
    React.useEffect(() => {
        var _a;
        if (uploadByCarrierState && uploadByCarrierState.data && !uploadByCarrierState.uploading) {
            setIsBackOpenOpen(false);
            setUploadedFileUrl((_a = uploadByCarrierState === null || uploadByCarrierState === void 0 ? void 0 : uploadByCarrierState.data) === null || _a === void 0 ? void 0 : _a.filePath);
            setFlag(false);
            enqueueSnackbar("Image shared by carrier uploaded successfuly", {
                variant: "success",
            });
        }
        else if (uploadByCarrierState.error) {
            setIsBackOpenOpen(false);
            if (uploadByCarrierState.error instanceof Error) {
                enqueueSnackbar(uploadByCarrierState.error.message, {
                    variant: "error",
                });
            }
        }
    }, [uploadByCarrierState]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Modal, { open: open, onClose: onClose },
            React.createElement(Box, { sx: style },
                React.createElement(Grid, { container: true, justifyContent: "space-between", alignItems: "center" },
                    React.createElement(Typography, { variant: "h6", fontWeight: 600 }, "Reason for rejection of disputed"),
                    React.createElement(IconButton, { onClick: onClose },
                        React.createElement(CloseIcon, null))),
                React.createElement(Box, { sx: { my: 2, borderBottom: "1px solid #eee" } }),
                React.createElement(Grid, { container: true, spacing: 2 },
                    React.createElement(Grid, { item: true, xs: 12 },
                        React.createElement(Typography, { className: "tenant_key", mb: 0.5 }, "Select the reason for rejection of disputed"),
                        React.createElement(Select, { style: { width: "100%" }, size: "small", value: reason || "", onChange: (e) => setReason(e.target.value), className: "tenant_value" },
                            React.createElement(MenuItem, { value: "rejected_by_carrier" }, "Rejected by carrier"))),
                    React.createElement(Grid, { item: true, xs: 12 },
                        React.createElement(Typography, { variant: "body2", sx: { mb: 1 } }, "Upload images shared by the carrier"),
                        React.createElement(Box, { sx: {
                                border: "1px dashed #ccc",
                                borderRadius: "8px",
                                p: 3,
                                textAlign: "center",
                            } },
                            React.createElement("img", { src: require("../../../assets/Onboarding/Upload_Icon.svg").default }),
                            React.createElement(Typography, { variant: "body2" }, "Upload image (PNG, JPG, JPEG, PDF, BMP)"),
                            React.createElement(Typography, { variant: "caption", color: "text.secondary" }, "Drag and drop files here"),
                            React.createElement(Box, { sx: { mt: 2 } },
                                React.createElement(Button, { variant: "outlined", component: "label" },
                                    "Browse file",
                                    React.createElement("input", { type: "file", hidden: true, onChange: handleFileChange, accept: ".png,.jpg,.jpeg,.pdf,.bmp,image/png,image/jpeg,application/pdf" }))),
                            file && (React.createElement(Box, { sx: {
                                    mt: 2,
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                } },
                                React.createElement(Typography, { variant: "body2" }, file.name),
                                React.createElement(Button, { size: "small", variant: "contained", onClick: handleUploadFile, disabled: !!uploadedFileUrl, sx: { textTransform: "none" } }, uploadedFileUrl ? "Uploaded" : "Upload")))))),
                React.createElement(Grid, { container: true, justifyContent: "flex-end", spacing: 2, sx: { mt: 3 } },
                    React.createElement(Grid, { item: true },
                        React.createElement(Button, { variant: "outlined", onClick: onClose, sx: { borderRadius: "8px", textTransform: "none" } }, "Cancel")),
                    React.createElement(Grid, { item: true },
                        React.createElement(Button, { variant: "contained", color: "error", sx: { borderRadius: "8px", textTransform: "none" }, onClick: handleRejectDispute, disabled: !uploadedFileUrl }, "Confirm")))))));
};
export default RejectDisputeBulkModal;
